var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"theme":"orange","title":"审核通过情况"}},[_c('chart-pie',{staticClass:"chart",attrs:{"colors":['#FF9D6B', '#FFE369'],"dataList":_vm.dataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }